export default __webpack_public_path__ + "static/fatih-karagumruk-logo-34443ba657fdd60c86fa47b8c7e3d171.png";